import React from 'react';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {useChangelog} from '../context/ChangelogContext';
import {useSidebar} from '../../../shared/context/SidebarContext';
import '../styles/changelog.css';

const ChangelogWidget = () => {
  const {recentEntries, loading} = useChangelog();
  const {isCollapsed} = useSidebar();
  const history = useHistory();

  if (isCollapsed || loading || recentEntries.length === 0) return null;

  const getTimestamp = (entry) => {
    if (!entry.publishedAt) return '';
    const date = entry.publishedAt.toDate ? entry.publishedAt.toDate() : new Date(entry.publishedAt);
    return moment(date).fromNow();
  };

  return (
    <div className="changelog-widget">
      <div className="changelog-widget-header">Latest from our changelog</div>
      <div className="changelog-widget-list">
        {recentEntries.map((entry) => (
          <div
            key={entry.id}
            className="changelog-widget-entry"
            onClick={() => history.push(`/changelog/${entry.id}`)}
            style={{cursor: 'pointer'}}
          >
            <span className="changelog-widget-dot" />
            <div className="changelog-widget-content">
              <span className="changelog-widget-time">{getTimestamp(entry)}</span>
              <span className="changelog-widget-title">{entry.title}</span>
            </div>
          </div>
        ))}
      </div>
      <span
        className="changelog-widget-link"
        tabIndex={0}
        onClick={() => history.push('/changelog')}
        onKeyDown={(e) => { if (e.key === 'Enter') history.push('/changelog'); }}
      >
        View changelog →
      </span>
    </div>
  );
};

export default ChangelogWidget;
